module.exports = __webpack_public_path__ + "img/portfolio-2.32022547.jpg";